import { RazorTextTrim } from "../../../components/razor-reuse";
import { useDispatch, useSelector } from "react-redux";
import ReuseModal from "../../../components/fragment/modal/ReuseModal";
import { deleteRoleFunc } from "../../../redux/role";
import RootState from "../../../redux/type";
import { capitalizeFirstLetter } from "../../../utils/Helper";

interface myComponentProps {
  onClose?: () => void;
  onFinish?: () => void;
  visible?: boolean;
  details?: any;
}

const DeleteRoleModal = ({
  onClose,
  visible,
  details,
  onFinish,
}: myComponentProps) => {
  const { loading_create } = useSelector((state: RootState) => state.roles);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const obj = {
      role_id: details?.id || "",
    };
    const data = await dispatch(deleteRoleFunc(obj) as any);

    if (data?.payload?.data?.status) {
      onFinish?.();
    }
  };

  return (
    <>
      <ReuseModal
        visible={visible}
        onClose={onClose}
        deleteType
        onBtnClick={handleSubmit}
        loading={loading_create}
        btnLabel="Delete Role"
        title={`Delete Role ( ${
          details?.name
            ? RazorTextTrim(
                capitalizeFirstLetter(details?.name?.replaceAll("_", " ")),
                16
              )
            : ""
        } )`}
        deleteText="Are you sure you want to delete this Role? Once confirmed, this would permanently delete this information from the database."
      />
    </>
  );
};

export default DeleteRoleModal;
